export default __webpack_public_path__ + "static/media/Boots of the Stormbringer.ea2849f0.jpg";